import { type FunctionComponent } from 'react';

export type ModelProps = {
	modelNumber: string;
	truncate?: boolean;
};

export const Model: FunctionComponent<ModelProps> = ({ modelNumber, truncate = true }) => {
	return <div className={`f6 lh-title theme-grey ${truncate ? 'truncate' : ''}`}>Model: {modelNumber}</div>;
};
